import { schema } from 'normalizr';
import ApplicationDataTabVariableConfigurationSchema from './ApplicationDataTabVariableConfigurationSchema';

const ApplicationDataTabCardSchema = new schema.Entity('applicationDataTabCards', {
  fields: [ApplicationDataTabVariableConfigurationSchema],
});

export default ApplicationDataTabCardSchema;
